import React from "react";
import { GoalTypeShape } from "../interfaces/classTypes";

let includedPatientGoalTypes = [];
export class PatientGoalType {
  public handle: string;
  public id: number;
  public label: string;
  public name: string;

  constructor(data: GoalTypeShape) {
    this.handle = data.handle;
    this.id = data.id;
    this.label = data.label;
    this.name = data.name;
    this.save();
  }
  save() {
    includedPatientGoalTypes.push(this);
  }
  static includedPatientGoalTypes() {
    return includedPatientGoalTypes;
  }

  static findByName(name) {
    return includedPatientGoalTypes.find((type) => type.name == name);
  }
}
